var chunk = function(arr, size) {
  var chunkSize = Math.max(size, 1);
  return arr.reduce(function(chunks, element, index) {
    var chunkIndex = Math.floor(index / chunkSize);
    if (!chunks[chunkIndex]) {
      chunks[chunkIndex] = [];
    }
    chunks[chunkIndex].push(element);
    return chunks;
  }, []);
};
export {
  chunk
};
//# sourceMappingURL=chunk.js.map
